(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anmeldelse"] && !Shopify.designMode) return;
  try {
    
/* Tilføj eventuel brugerdefineret JavaScript her */

  } catch(e) { console.error(e); }
})();
})();
